forms-products-search
  form.form.row(action="{ opts.action }" method="{ opts.method }" onSubmit="{ this.onSubmit }")
    inputs-hidden(tag-scope="{ this.tagScope }.inputs.method")
    inputs-hidden(tag-scope="{ this.tagScope }.inputs.authenticity_token")
    .col-12.col-md-10
      inputs-search-keyword(tag-scope="{ this.tagScope }.inputs.keyword")
    .col-12.col-md-2
      inputs-search-submit(tag-scope="{ this.tagScope }.inputs.submit")
  script(type="typescript").
    this.mixin('forms.products.search')
